export function mounted() {
  this.getList()
}
